import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, title, style, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: 'white',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      overflow: 'hidden',
      cursor: onClick ? 'pointer' : 'default',
      transition: onClick ? 'all 0.15s' : 'none',
      ...style,
    }}
  >
    {title && (
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', fontWeight: 600, fontSize: '14px', background: 'var(--bg-secondary)' }}>
        {title}
      </div>
    )}
    <div style={{ padding: '16px' }}>{children}</div>
  </div>
);
